export class StickyFooterLogo {
	constructor() {
		this.footer = document.querySelector(".footer");
		this.footerLogo = this.footer?.querySelector(
			".footer-logos__item:first-child a"
		);

		if (!this.footerLogo) return;

		this.init();
	}

	init() {
		this.createStickyLogo();
	}

	createStickyLogo() {
		const footerLogoClone = this.footerLogo.cloneNode(true);
		footerLogoClone.classList.add("footer-logos__link--clone");
		footerLogoClone.setAttribute("aria-hidden", "true");
		footerLogoClone.setAttribute("tabindex", "-1");

		// Append the clone to the body
		document.body.appendChild(footerLogoClone);
	}
}
